import { Circle, ListChecks, LucideIcon } from "lucide-react";

const ChoicesSection = ({
  choices = [],
  title = "",
  defaultText = "",
  icon: Icon = ListChecks,
}: {
  choices: string[];
  title: string;
  defaultText: string;
  icon: LucideIcon;
}) => {
  const color = "blue";

  return (
    <div className={`p-4 bg-${color}-50 border border-${color}-900 rounded-lg`}>
      <div className="flex items-center mb-2">
        <Icon className={`w-4 h-4 text-${color}-600 mr-2`} />
        <h3 className={`font-medium text-${color}-900`}>{title}</h3>
      </div>
      {choices.length > 0 ? (
        <ul className="divide-y divide-gray-200">
          {choices.map((choice, index) => (
            <li
              key={`choice-${title}-${index}`}
              className={`px-3 py-2 text-md flex items-center`}
            >
              <Circle
                className={`w-1 h-1 mr-3 fill-current text-${color}-600`}
              />
              {choice}
            </li>
          ))}
        </ul>
      ) : (
        <p className={`text-sm text-${color}-800`}>{defaultText}</p>
      )}
    </div>
  );
};

export default ChoicesSection;
